import axios from 'axios';
import hdk from '@/lib/hdk';
import setter from '@/lib/setter';
import store from '@/store';
import {
    Toast,
    Dialog
} from 'vant';

const instance = axios.create({
    baseURL: setter.baseURL,
    withCredentials: true,
    method: 'post',
    timeout: 0,
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    }
});

instance.interceptors.request.use(
    config => {
        config.headers[setter.tokenName] = hdk.data(setter.tokenName) ? hdk.data(setter.tokenName) : '';
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    response => {
        if (200 === response.status) {
            /**
             * 正常 200
             * 登陆超时 401
             * 无效凭证 403
             * 普通错误 40000 进入catch 返回message 可以不处理但是必须加上catch
             * 业务错误 40001~49999 业务错误进入catch里继续处理
             */
            if (response.data.success) {
                if (200 === response.data.code) {
                    return Promise.resolve({
                        data: response.data.data,
                        headers: response.headers
                    });
                }
            } else {
                /**
                 * 返回登陆页面
                 */
                if (401 === response.data.code || 403 === response.data.code) {
                    hdk.data({
                        key: setter.tokenName,
                        remove: true
                    });

                    window.location = '/login?to=login';

                    return Promise.reject(response.data.message);
                }
                /**
                 * 普通错误处理
                 */
                else if (40000 === response.data.code) {
                    Toast(response.data.message);
                    return Promise.reject(response.data.message);
                }
                /**
                 * 处理自定义业务错误时必须判断code是否一致
                 * loginApi.login(this.loginInfo.loginAccount, this.loginInfo.password)
                 *   .then(res => {
                 *       doSomething...
                 *   })
                 *   .catch((res) => {
                 *       if (40001 === res.code){
                 *           doSomething...
                 *       }
                 *   })
                 *   .finally(() => {
                 *       doSomething...
                 *   });
                 *
                 */
                else if (40000 < response.data.code) {
                    return Promise.reject(response.data);
                }
            }
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        if (error.response.data.message) {
            Toast(error.response.data.message);
        } else {
            Toast(error.message);
        }
        return Promise.reject(error);
    }
);


export default instance